import { gql } from 'graphql.macro';

export const GetOpportunityList = gql`
    query GetOpportunityRecords($request: ObservationFilterRequestInput) {
        opportunityRecords(request: $request) {
            observationId
            locationType
            locationTypeDescription
            offSiteLocation
            {
                customerSiteName
                locationDescription
            }
            depotPcId
            depotPC
            depotPcName
            divisionId
            divisionName
            regionId
            regionName
            sHEQManagerId
            sHEQManager
            observationCategoryName
            observationCategoryNameDE
            whatHappened
            whoShouldBeCommended
            observationStatus
            incidentDate
            processName
            reachName
        }
    }
`;
